<div class="grid pb-3">
    <div class="col-12 md:col-8  pb-0 align-middle">
        <label [class]="props.className"> <strong>{{props.label}}</strong></label>
    </div>
    <div class="col-12 md:col-8 py-0 align-middle">
        <textarea rows="3"  class="w-100" pInputTextarea  [name]="key+''"   [id]="key+''" [formControl]="formControl" [formlyAttributes]="field"></textarea>
    </div>
</div>